import { IsString, IsPhoneNumber, IsNotEmpty, IsUUID } from 'class-validator';

export class LoginInitDto {
  @IsPhoneNumber('RU', {
    groups: ['form'],
    message: 'Неверный номер телефона',
  })
  @IsString({
    groups: ['form'],
    message: 'Вы забыли ввести номер телефона',
  })
  @IsNotEmpty({
    groups: ['form'],
    message: 'Вы забыли ввести номер телефона',
  })
  phone: string;

  @IsString({
    groups: ['form'],
    message: 'Вы забыли ввести пароль',
  })
  @IsNotEmpty({
    groups: ['form'],
    message: 'Вы забыли ввести пароль',
  })
  password: string;

  @IsUUID()
  @IsNotEmpty()
  auth_instance_id: string;
}
